import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class TaxFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default TaxFormPresenter;
